import React, { createContext, useContext, useState } from 'react';
import { Ownership } from '../../../types';

interface OwnershipContextType {
  ownershipSelected: Ownership | null;
  setOwnershipSelected: (ownership: Ownership | null) => void;
}

const OwnershipContext = createContext<OwnershipContextType | undefined>(undefined);

interface OwnershipProviderProps {
  children: React.ReactNode;
}

export const OwnershipProvider: React.FC<OwnershipProviderProps> = ({ children }) => {
  const [ownershipSelected, setOwnershipSelected] = useState<Ownership | null>(null);

  return (
    <OwnershipContext.Provider value={{ ownershipSelected, setOwnershipSelected }}>
      {children}
    </OwnershipContext.Provider>
  );
};

export const useOwnership = (): OwnershipContextType => {
  const context = useContext(OwnershipContext);
  if (context === undefined) {
    throw new Error('useOwnership must be used within an OwnershipProvider');
  }
  return context;
};

